<template>
	<div class="limitations">
		<div class="limitations__title">Term Life</div>
		<div class="limitations__form">Forms G L2307/G L2307C</div>
		<p>
			<span class="limitations__subhead">Limitations</span>
		</p>
		<p>
			Availability of this product, and its benefits and premiums as
			presented, is subject to the approval of Assurity. Product
			availability, features and rates may vary by state. All benefits,
			premiums, conditions, exclusions and limitations are governed by the
			actual contract as provided by Assurity, not this proposal.
		</p>
		<p>
			<b>Suicide</b> – If an Insured Person dies by suicide within two
			years of the issue date or last reinstatement date, Assurity's
			liability is limited to a refund of premiums paid for coverage
			provided for that Insured Person, less any benefits paid under this
			Certificate or any riders.
		</p>
		<p>
			(In California and Nebraska)<br />
			If an Insured Person dies by suicide within two years of the issue
			date, Assurity's liability is limited to a refund of premiums paid
			for coverage provided for that Insured Person, less any benefits
			paid under this Certificate or any riders.
		</p>
		<p>
			(In Maine)<br />
			If an Insured Person dies by suicide within two years of the issue
			date or an increase in coverage, Assurity's liability is limited to
			a refund of premiums paid for coverage provided for that Insured
			Person, less any benefits paid under this Certificate or any riders.
		</p>
		<p>
			(In Missouri)<br />
			If an Insured Person dies by suicide within one year of the issue
			date or any addition or increase in death benefit, Assurity's
			liability is limited to a refund of premiums paid for coverage
			provided for that Insured Person, less any benefits paid under this
			Certificate or any riders.
		</p>
		<p>
			(In Minnesota)<br />
			If an Insured Person dies by suicide within one year of the issue
			date or last reinstatement date, Assurity’s liability is limited to
			a refund of premiums paid for coverage provided for that Insured
			Person, less any benefits paid under this Certificate or any riders.
		</p>
		<p>
			(In North Dakota)<br />
			If an Insured Person dies by suicide within one year of the issue
			date or last reinstatement date, Assurity's liability is limited to
			a refund of premiums paid for coverage provided for that Insured
			Person, less any benefits paid under this Certificate or any riders.
		</p>
		<p>
			(In Louisiana)<br />
			If an Insured Person dies by suicide within two years of the issue
			date, Assurity's liability is limited to a refund of premiums paid
			for coverage provided for that Insured Person, less any benefits
			paid under this Certificate or any riders.
		</p>
		<p>
			(In Colorado)<br />
			If an Insured Person dies by suicide within one year of the issue
			date, Assurity's liability is limited to a refund of premiums paid
			for coverage provided for that Insured Person, less any benefits
			paid under this Certificate or any riders.
		</p>
		<p>
			(In Washington)<br />
			N/A
		</p>

		<p>
			<b><u>Coverage Conditions</u></b>
		</p>
		<p>
			<b>Actively Employed</b> – The employee must be actively employed to
			be eligible for coverage.
		</p>
		<p>
			<b>Right to Cancel</b> – The contract contains a 30-day free look
			period.
		</p>
		<p>
			<b>Termination</b> – Term life insurance coverage will terminate the
			earliest of the following: the date policy terminates for any reason
			(portability available); the date employee is no longer an employee
			(portability available); when premiums are not paid by the end of
			the grace period; the anniversary after the Insured Person’s 95th
			birthday (the expiration date listed on the schedule); the date
			Assurity receives written notice to terminate unless the notice
			specifies a later date; or upon the Insured Person’s Death. Coverage
			provided by rider subject to different termination provision – see
			rider language for details.
		</p>

		<p>
			<span class="limitations__subhead"
				>Limitations for Disability Waiver of Premium Rider</span
			>
		</p>
		<ul>
			<li>The premium waived will correspond to the premium mode.</li>
			<li>
				Premiums will only be waived while the Insured Person is alive.
			</li>
			<li>
				(in New Jersey) – Premiums will only be waived while the Primary
				Insured Person is alive.
			</li>
			<li>
				Premiums will only be waived until the Waiver of Premium Rider
				terminates.
			</li>
			<li>
				Premiums will be refunded from the date of total disability, but
				in no event will premiums be refunded more than one year prior
				to the date notice of claim is received at Assurity's
				administrative office.
			</li>
			<li>
				Premiums must continue to be paid when due until the Insured
				Person's total disability claim is approved.
			</li>
			<li>
				(in New Jersey) – Premiums must continue to be paid by the
				Policyholder when due until the Primary Insured Person's total
				disability claim is approved.
			</li>
			<li>
				If total disability starts during a grace period, the premium
				due must be paid before subsequent premiums will be waived.
			</li>
			<li>
				(in New Jersey) – If total disability starts during a grace
				period, the premium due must be paid by the Policyholder before
				subsequent premiums will be waived.
			</li>
			<li>Coverage cannot be changed while premiums are being waived.</li>
		</ul>

		<p>
			<span class="limitations__subhead"
				>Exclusions for Disability Waiver of Premium Rider</span
			>
		</p>
		<p>
			Assurity will not pay benefits for losses under the Disibility
			Waiver of Premium Rider caused by or the result of any Insured
			Person(s):
		</p>
		<ul>
			<li>
				being exposed to war or any act of war, declared or undeclared;
				or
			</li>
			<li>
				(in North Carolina) – being exposed to war or any act of war,
				declared or undeclared (undeclared war does not include acts of
				terrorism), unless the Insured Person is a known service member
				and such information was provided at the time of application; or
			</li>
			<li>intentionally self-inflicting an Injury or Sickness.</li>
			<li>
				(in Illinois) – intentionally self-inflicting an Injury or
				Illness.
			</li>
		</ul>

		<p>
			<span class="limitations__subhead"
				>Exclusions for Accidental Death Benefit Rider</span
			>
		</p>
		<p>
			Assurity will not pay benefits for losses under the Accidental Death
			Benefit Rider caused by or the result of any Insured Person(s):
		</p>
		<ul>
			<li>
				operating, learning to operate or serving as a crew member of
				any aircraft;
			</li>
			<li>
				(in California) – engaging in aviation, other than as a
				fare-paying passenger;
			</li>
			<li>(in Idaho) – NA</li>
			<li>
				engaging in hang-gliding, hot air ballooning, bungee jumping,
				parachuting, scuba diving, sail gliding, parasailing,
				parakiting, mountain or rock climbing, B.A.S.E. jumping, sky
				diving or cave diving;
			</li>
			<li>(in California, Iowa, Idaho, Illinois and Utah) – NA</li>
			<li>
				riding in or driving any motor-driven vehicle in an organized
				race, stunt show or speed test;
			</li>
			<li>
				(in Idaho) – riding in or driving professionally in any
				motor-driven vehicle in an organized race, stunt show or speed
				test;
			</li>
			<li>(in California, Iowa, Illinois and Utah) – NA</li>
			<li>
				officiating, coaching, practicing for or participating in any
				semi-professional or professional competitive athletic contest
				for which any type of compensation or remuneration is received;
			</li>
			<li>
				(in Idaho) – officiating, coaching, practicing for or
				participating in any professional competitive athletic contest
				for which any type of compensation or remuneration is received;
			</li>
			<li>(in California, Illinois and Utah) – NA</li>
			<li>
				having a sickness, disease or infection other than infection
				from an Accidental Bodily Injury received while this rider is in
				force;
			</li>
			<li>
				(in Illinois) – having an illness, disease or infection other
				than infection from an Accidental Bodily Injury received while
				this rider is in force;
			</li>
			<li>(in Vermont) – NA</li>
			<li>
				being exposed to war or any act of war, declared or undeclared;
			</li>
			<li>
				(in Oregon) – being exposed to war or any act of war,
				declared or undeclared. This does not include terrorist acts,
				other random acts of violence not perpetrated by the Insured
				Person, civil war, or a local or community faction;
			</li>
			<li>
				(in North Carolina) – being exposed to war or any act of war,
				declared or undeclared (undeclared war does not include acts of
				terrorism);
			</li>
			<li>(in Massachusetts) – NA</li>
			<li>
				actively serving in any of the armed forces or units auxiliary
				thereto, including the National Guard or any Reserve, except
				during the active duty training of less than 60 days;
			</li>
			<li>(in California and Massachusetts) – NA</li>
			<li>being addicted to drugs or suffering from alcoholism;</li>
			<li>(in District of Columbia) – suffering from alcoholism;</li>
			<li>(in Illinois) – having a substance use disorder;</li>
			<li>
				(in Nebraska) – being addicted to drugs, including those
				prescribed by a Physician that are misused, or suffering from
				alcoholism;
			</li>
			<li>
				(in Florida) – being addicted to drugs or suffering from
				alcoholism as reported by a medical professional;
			</li>
			<li>
				(in California, New Jersey, Maryland, Missouri, South Dakota and
				Connecticut) – NA
			</li>
			<li>
				being under the influence of an excitant, depressant,
				hallucinogen, narcotic, or any other drug or intoxicant,
				including those prescribed by a Physician that are misused;
			</li>
			<li>
				(in District of Columbia) – intentionally misusing prescription
				drugs;
			</li>
			<li>
				(in District of Columbia) - voluntarily using illegal drugs;
			</li>
			<li>
				(in District of Columbia) - intentionally taking over-the-counter medication not in
				accordance with recommended dosage and warning instructions;
			</li>
			<li>
				(in Utah) – participating in and being found guilty of any
				illegal activity as a direct result of being under the influence
				of an illegal substance, excitant, depressant, hallucinogen,
				narcotic, or any other drug or intoxicant, including those
				prescribed to the Insured Person by a Physician that are
				misused;
			</li>
			<li>
				(in California, Connecticut, New Jersey, Maryland, South Dakota,
				Vermont and Washington) – NA
			</li>
			<li>
				being intoxicated (as determined by the laws governing the
				operation of motor vehicles in the jurisdiction where loss
				occurs) or under the influence of an illegal substance or a
				narcotic (except for narcotics used as prescribed to the Insured
				Person by a Physician);
			</li>
			<li>
				(in California) – being intoxicated as defined in the
				jurisdiction where the loss occurs;
			</li>
			<li>
				(in Maryland) – being intoxicated or under the influence of any
				narcotic;
			</li>
			<li>
				(in New Jersey) – being intoxicated or under the influence of
				any narcotic unless administered or consumed on the advice of a
				Physician;
			</li>
			<li>
				(in Utah) – participating in and being found guilty of any
				illegal activity as a direct result of being intoxicated (as
				determined by the laws governing the operation of motor vehicles
				in the jurisdiction where loss occurs);
			</li>
			<li>
				(in District of Columbia) – being intoxicated (as determined by
				the laws governing the operation of motor vehicles in the
				jurisdiction where loss occurs);
			</li>
			<li>(in South Dakota, Washington and Vermont) – NA</li>
			<li>committing or attempting to commit a felony;</li>
			<li>
				(in Maryland) – having committed or attempting to commit a
				felony;
			</li>
			<li>(in Idaho) – committing a felony;</li>
			<li>
				(in Utah) – voluntarily participating in or attempting to commit
				a felony;
			</li>
			<li>
				(in Texas) – having committed or attempting to commit a felony;
			</li>
			<li>
				being incarcerated in a penal institution or government
				detention facility;
			</li>
			<li>
				(in New Jersey) – being incarcerated in a penal institution or
				government detention facility following conviction of a crime;
			</li>
			<li>(in California, Vermont and Utah) – NA</li>
			<li>participating in a riot, insurrection or rebellion;</li>
			<li>
				(in California) – participating in a riot, insurrection or
				terrorist activity;
			</li>
			<li>
				(in Connecticut) – participating (being involved) in a civil
				disorder or riot. "Riot" means acting with two or more other
				persons in a tumultuous and violent manner to intentionally or
				recklessly cause property damage or physical injury to others;
			</li>
			<li>
				(in Maryland) – voluntarily participating in a riot,
				insurrection or rebellion;
			</li>
			<li>
				(in North Carolina) – actively participating in a riot,
				insurrection or rebellion;
			</li>
			<li>
				(in Utah) – voluntarily participating in a riot, insurrection or
				rebellion;
			</li>
			<li>
				driving any taxi or passenger vehicle for wage, compensation or
				profit;
			</li>
			<li>(in California, Illinois, South Dakota and Vermont) – NA</li>
			<li>engaging in an illegal activity or occupation;</li>
			<li>(in California) – engaging in an illegal occupation;</li>
			<li>
				(in Connecticut) – engaging in a felonious activity or
				occupation;
			</li>
			<li>(in Utah) – voluntarily engaging in an illegal occupation;</li>
			<li>(in Illinois and Vermont) – NA</li>
			<li>intentionally self-inflicting an injury;</li>
			<li>(in Florida) – intentionally self-inflicting an injury;</li>
			<li>
				(in Colorado) – intentionally self-inflicting an injury, while
				sane;
			</li>
			<li>(in California) – NA</li>
			<li>
				committing or attempting to commit suicide, while sane or
				insane;
			</li>
			<li>
				(in California) – attempting to commit suicide or intentionally
				self-inflicted injury, while sane or insane;
			</li>
			<li>
				(in California) - voluntary using of any drug, unless prescribed or administered
				by a Physician and taken in accordance with the Physician’s
				instructions;
			</li>
			<li>
				(in California) - voluntary inhaling of poison, gas, or fumes, unless they are the
				direct result of an occupational accident.
			</li>
			<li>
				(in Colorado) – committing or attempting to commit suicide,
				while sane;
			</li>
			<li>
				(in Florida) – committing or attempting to commit suicide, while
				sane or insane;
			</li>
			<li>
				(in South Dakota and Vermont) – committing or attempting to
				commit suicide;
			</li>
			<li>(in Missouri and Washington) – NA</li>
			<li>
				traveling outside the United States or Canada for more than 14
				days.
			</li>
			<li>(in California and Florida) – NA</li>
		</ul>
		<p>
			(in Massachusetts) - We will not pay benefits for death as a direct result of war,
			declared or undeclared, while actively serving in any of the armed
			forces or units auxiliary thereto, including the National Guard or
			any Reserves, except during active duty training of less than 60
			days.
		</p>
		<p>
			For the purposes of this exclusion, the following terms are
			defined:<br />
			<b>War</b> includes, but is not limited to, declared war and armed
			aggression by one or more countries resisted on orders of any other
			county, combination of countries or international organization;<br />
			<b>Act of War</b> means any act peculiar to military, naval or air
			operations in time of war;<br />
			<b>Military</b> includes persons serving on active Reserve and Guard
			duty.
		</p>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.limitations {
	&__title {
		font-weight: bold;
		font-size: 1.2rem;
	}

	&__subhead {
		font-size: 1.1rem;
		display: block;
		margin-bottom: 5px;
	}

	ul {
		margin-bottom: 10px;
	}
}
</style>
